<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dicqVY/tc-custom/9780830849239.jpg?1696025332597" alt="This image is the cover for the book Out of the Saltshaker and Into the World, The IVP Signature Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Out of the Saltshaker and Into the World, The IVP Signature Collection
      </h1>
      <p class="bookDescription body article font2">
        <p>In 2006, <em>Christianity Today</em> voted this title to be one of the top 50 books that have shaped evangelicals Over 800,000 Sold  </p><p> <strong>Jesus says his followers are the salt of the earth.</strong> But many Christians struggle with this call to be active in the world as witnesses to Christ. The word <em>evangelism</em> often carries negative connotations. How do we cut through fear and guilt to communicate our faith freely and effectively?</p> <p>In this bestselling classic, Rebecca Manley Pippert offers a refreshing view of evangelism as a lifestyle. For over forty years, <em>Out of the Saltshaker and Into the World</em> has equipped believers of different backgrounds around the world. Using memorable stories, biblical insight, and practical communication techniques, Pippert points to Jesus as our model and helps us feel relaxed and enthusiastic about sharing the good news.</p> <p>This landmark work is now available as part of the IVP Signature Collection, which features special editions of iconic books in celebration of the seventy-fifth anniversary of InterVarsity Press.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Manley Pippert, Mark Mittelberg
      </h2>
      
      <p class="authorDescription body article"><p>Rebecca Manley Pippert is an internationally known author and speaker who inspires and equips Christians for personal evangelism at conferences and training events around the world. Her books include <em>A Heart for God</em>, <em>Hope Has Its Reasons</em>, <em>Stay Salt</em>, and the <em>Empowered</em> curriculum.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b0d6f66